<template>
<div class="container">
    <div v-for="(store,index) in storeCartList">
        <div class="store">
            <i class="iconfont">&#xe62d;</i>
            <span @click="$router.push({ name: 'HomeStoredetail', query: { id: store.store_id } })">{{store.store_name}}</span>
        </div>
        <ul class="cart-item">
            <li class="buy-item" v-for="goods in store.goods_list">
                <div class="goods-pic">
                  <img :src="goods.goods_image_url" @click="$router.push({name:'HomeGoodsdetail',query:{goods_id:goods.goods_id}})"/>
                </div>
                <div class="goods-info" :class="{ 'has-ship-from': getShipFrom(goods) }">
                    <dl>
                        <dt class="goods-name">
                            <a>
                                <i class="tag-icon" v-if="goods.xianshi_info">{{goods.xianshi_info.xianshi_title}}</i>
                                <i class="tag-icon" v-if="goods.ifgroupbuy">Panic buying</i>
                                <i class="tag-icon" v-if="goods.ifmgdiscount">Member discount</i>
                                <i class="tag-icon" v-if="goods.ifpintuan">Group work</i>
                                <i class="tag-icon" v-if="goods.ifbargain">Bargain</i>
                                <i class="tag-icon" v-if="goods.bl_id">Discount package</i>
                                <i class="tag-icon" v-if="goods.is_sample == 1">Sample</i>
                                {{goods.goods_name}}
                            </a>
                        </dt>
                        <dd v-if="getShipFrom(goods)" class="goods-ship-from">
                            Ship from: {{getShipFrom(goods)}}
                        </dd>
                        <dd class="goods-subtotal">
                            <span class="goods-price">${{goods.goods_price}}</span>
                            <span v-if="!isSampleOrder && getOriginalPrice(goods)" class="ml-5 goods-original-price">${{getOriginalPrice(goods)}}</span>
                            <span class="goods-count">
                              ×
<!--                              {{goods.goods_num}}-->
                              <span v-if="isSampleOrder" class="number readonly">{{goods.goods_num}}</span>
                              <input v-else type="number" min="1" class="number" v-model="goods.goods_num" @change.prevent="inputLoseFocus(goods.cart_id, goods.goods_num, goods.moq_num)">
                            </span>
                        </dd>
                        <dd class="goods-subtotal" v-if="goods.moq_num > 0">
                            <span class="goods-minorder">MOQ: {{goods.moq_num}}</span>
                        </dd>
                        <dd>
                            <div class="link" v-if="goodsCount>1 && chainList[goods.goods_id] && chainList[goods.goods_id].length" @click="goBuy(goods.goods_id,goods.goods_num)">Pickup points can be used in the current area</div>
                            <div v-else>
                                <div class="link" v-if="addressApi.allow_offpay==1 && ifshowOffpay && offlineList[goods.goods_id]">This product supports cash on delivery</div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </li>
            <li class="buy-item" v-if="store.store_mansong_rule_list && store.store_mansong_rule_list.goods_id != 0 && store.store_mansong_rule_list.mansong_goods_name != ''" @click="$router.push({name:'HomeGoodsdetail',query:{goods_id:store.store_mansong_rule_list.goods_id}})">
                <div class="goods-pic"><img :src="store.store_mansong_rule_list.goods_image_url"/></div>
                <div class="goods-info">
                    <dl>
                        <dt class="goods-name">
                            <a>
                                <i class="tag-icon">Giveaway</i>
                                {{store.store_mansong_rule_list.mansong_goods_name}}
                            </a>
                        </dt>
                        <dd class="goods-subtotal">
                            <span class="goods-price">0.00</span>
                            <span class="goods-count">×1</span>
                        </dd>
                    </dl>
                </div>
            </li>
        </ul>

        <div class="cart-subtotal">
          <div v-if="store.store_voucher_list.length" @click="toggleVoucher(store.store_id)">
            <mt-cell class="menu-item" title="Voucher" >
              <span slot="icon" class="left-icon iconfont">&#xe6f2;</span>
              <span style="color: #ff5000;">{{myVoucher[store.store_id]}}</span>
              <i class="indicator iconfont">&#xe650;</i>
            </mt-cell>
          </div>
        </div>

<!--        <div class="cart-subtotal">
            <div v-if="goodsCount == 1 && chainCount > 0" @click="showChain=true">
              <mt-cell class="menu-item" title="Pick up shop" >
                <span slot="icon" class="left-icon iconfont">&#xe6d3;</span>{{chainInfo?chainInfo.chain_addressname:'Select'}}<i class="indicator iconfont">&#xe650;</i>
              </mt-cell>
            </div>
            <div v-if="store.store_voucher_list.length" @click="toggleVoucher(store.store_id)">
              <mt-cell class="menu-item" title="Voucher" >
                <span slot="icon" class="left-icon iconfont">&#xe6f2;</span>{{myVoucher[store.store_id]}}<i class="indicator iconfont">&#xe650;</i>
              </mt-cell>
            </div>
            <div class="message">
              <mt-field label="Remarks" placeholder="Shop order message:" type="textarea" v-model="message[store.store_id]" @change="changeMessage(store.store_id)"></mt-field>
            </div>
            <div class="volume mt-5">
              <label class="title">Estimated volume</label>
              <label class="subtitle">{{ store.store_goods_volume_total }} m³</label>
            </div>
            <div class="volume">
              <label class="title">Gross weight</label>
              <label class="subtitle">{{ store.store_goods_weight_total }} kg</label>
            </div>
            <checkout-desc class="desc-item" title="Commodity amount" :subtitle="store.store_goods_original_total"></checkout-desc>
            <checkout-desc class="desc-item" title="Discount" v-if="store.store_mansong_rule_list || store.store_goods_discount_total > 0" :subtitle="Math.round(((store.store_mansong_rule_list.discount?parseFloat(store.store_mansong_rule_list.discount):0)+parseFloat(store.store_goods_discount_total))*100)/100" :discount="true"></checkout-desc>
            <checkout-desc class="desc-item" title="Shipping" :subtitle="chainInfo ? 0 : addressApi.content[store.store_id]"></checkout-desc>
            <checkout-desc class="desc-item" title="Total amount" :subtitle="totalAmount[store.store_id]"></checkout-desc>
            <div class="cart_item" v-if="pay_code == 'offline'">
              <div class="dl">
                <div class="dt">Proportion of initial payment</div>
                <div class="dd">
                  <select class="select" v-model="initial_ratio" @change="changeInitial($event,store.store_id)">
                    <option v-for="item in initial_items" :value="item.id">{{item.name}}</option>
                  </select>
                </div>
              </div>
              <div class="dl">
                <div class="dt">The total amount of initial payment</div>
                <div class="dd"><em>${{totalAmount2[store.store_id]}}</em></div>
              </div>
            </div>
        </div>-->

        <mt-popup v-model="voucherVisible[store.store_id]" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="Voucher" class="common-header">
                    <mt-button slot="left" icon="back" @click="toggleVoucher(store.store_id)"></mt-button>
                    <mt-button slot="right" @click="selectVoucher('',store.store_id)">Not used</mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div class="common-voucher common-voucher02" :class="(item.voucher_state != 1)?'disable':''" v-for="(item,index) in store.store_voucher_list" :key="item.voucher_id" @click="selectVoucher(item,store.store_id)">
                    <div class="par"><p>Order full {{item.voucher_limit}} dollar</p><sub class="sign">$</sub><span>{{item.voucher_price}}</span></div>
                    <div class="copy">Valid until <p><br>{{$moment.unix(item.voucher_enddate).format('YYYY.MM.DD')}}</p></div>
                    <i></i>
                </div>
            </div>
        </mt-popup>

        <div v-if="goodsCount==1 && chainCount>0">
            <mt-popup v-model="showChain" position="right" class="common-popup-wrapper">
                <div class="common-header-wrap">
                    <mt-header title="Pick up shop" class="common-header">
                        <mt-button slot="left" icon="back" @click="showChain=false"></mt-button>
                        <mt-button slot="right" @click="selectChain(false)">Not used</mt-button>
                    </mt-header>
                </div>
                <div class="common-popup-content">
                    <div v-for="(temp,index) in chainList" :key="index">
                        <div class="chain-item" v-for="(chain,i) in temp" :key="i" @click="selectChain(chain)">
                            <div class="chain-name">{{chain.chain_addressname}}</div>
                            <div class="chain-desc">{{chain.chain_area_info}}{{chain.chain_address}}</div>
                        </div>
                    </div>
                </div>
            </mt-popup>
        </div>

    </div>

    <div class="cart-subtotal">
      <div class="volume mt-5">
        <label class="title">Estimated volume</label>
        <label class="subtitle">{{ displayVolume(storeTotal.goods_volume) }} m³</label>
      </div>
      <div class="volume">
        <label class="title">Gross weight</label>
        <label class="subtitle">{{storeTotal.goods_weight}} kg</label>
      </div>

      <checkout-desc class="desc-item" title="Shipping" :subtitle="totalShipping"></checkout-desc>
      <checkout-desc class="desc-item" title="Total amount" :subtitle="storeTotal.order_amount" :originalSubtitle="isSampleOrder ? '' : totalOriginalAmount"></checkout-desc>
      <div class="cart_item" v-if="pay_code == 'offline' && !isSampleOrder">
        <div class="dl">
          <div class="dt">Proportion of deposit</div>
          <div class="dd">
            <button type="button" class="deposit-select" @click="openDepositRatio">{{selected_initial_ratio}}%</button>
          </div>
        </div>
        <div class="dl">
          <div class="dt">The total amount of deposit</div>
          <div class="dd"><em>${{order_amount2}}</em></div>
        </div>
      </div>
      <mt-popup v-model="depositRatioVisible" position="bottom" class="deposit-ratio-popup">
        <div class="deposit-picker">
          <div class="deposit-picker-hd">
            <span>Proportion of deposit</span>
            <button type="button" @click="depositRatioVisible=false">Done</button>
          </div>
          <div class="deposit-options">
            <button
              type="button"
              v-for="item in initial_items"
              :key="item.id"
              :class="{ active: selected_initial_ratio == item.id }"
              @click="selectDepositRatio(item.id)"
            >{{item.name}}</button>
          </div>
        </div>
      </mt-popup>
    </div>

</div>
</template>
<script>
import { getChainList, getGoodsInfo } from '../../../../api/homegoodsdetail'
import CheckoutDesc from './CheckoutDesc'
import { Indicator, Toast } from 'mint-ui'
import { cartUpdate } from '@/api/homecart'
export default {
  name: 'CheckoutStore',
  data () {
    return {
      totalAmount: {},
      totalAmount2: {},
      order_amount2: 0,
      myVoucher: [],
      voucherVisible: [],
      message: [],
      chainList: {},
      offlineList: {},
      goodsCount: 0,
      chainCount: 0,
      showChain: false,
      chainInfo: false,
      goodsInfo: false,
      selected_initial_ratio: this.initial_ratio || '10',
      depositRatioVisible: false,
      originalPriceMap: {},
      initial_items: [
        { id: '10', name: '10%' },
        { id: '20', name: '20%' },
        { id: '30', name: '30%' },
        { id: '40', name: '40%' },
        { id: '50', name: '50%' },
        { id: '60', name: '60%' },
        { id: '70', name: '70%' },
        { id: '80', name: '80%' },
        { id: '90', name: '90%' },
        { id: '100', name: '100%' }
      ]
    }
  },
  components: {
    CheckoutDesc
  },
  props: ['payGoodsList', 'addressInfo', 'storeCartList', 'addressApi', 'finalTotalList', 'ifshowOffpay', 'pay_code', 'storeTotal', 'initial_ratio', 'isSampleOrder'],
  computed: {
    totalShipping () {
      if (this.chainInfo || !this.addressApi || !this.addressApi.content) {
        return '0.00'
      }
      var shipping = 0
      var storeIds = Object.keys(this.storeCartList || {})
      for (var i = 0; i < storeIds.length; i++) {
        var storeShipping = parseFloat(this.addressApi.content[storeIds[i]] || 0)
        if (!isNaN(storeShipping) && storeShipping > 0) {
          shipping += storeShipping
        }
      }
      return (Math.round(shipping * 100) / 100).toFixed(2)
    },
    totalOriginalAmount () {
      var total = 0
      var hasOriginalPrice = false
      var stores = this.storeCartList || {}
      for (var storeId in stores) {
        var goodsList = stores[storeId].goods_list || []
        for (var i = 0; i < goodsList.length; i++) {
          var goods = goodsList[i]
          var originalPrice = this.getOriginalPrice(goods)
          if (originalPrice) {
            hasOriginalPrice = true
          }
          total += parseInt(goods.goods_num || 0) * parseFloat(originalPrice || goods.goods_price || 0)
        }
      }
      total += parseFloat(this.totalShipping || 0)
      return hasOriginalPrice && total > Number(this.storeTotal.order_amount) ? total.toFixed(2) : ''
    }
  },
  created: function () {
    if (this.payGoodsList.offline) {
      var offlineList = {}
      for (var i in this.payGoodsList.offline) {
        offlineList[this.payGoodsList.offline[i].goods_id] = 1
      }
      this.offlineList = offlineList
    }

    this.calcOrder2()

    for (var store_id in this.storeCartList) {
      // this.calcOrder(store_id)
      if (this.addressInfo) {
        var store = this.storeCartList[store_id]
        for (var i in store.goods_list) {
          this.goodsCount++
          var goods = store.goods_list[i]
          this.goodsInfo = goods
          this.getChainList(goods.goods_id, goods.goods_num, this.addressInfo.area_id)
        }
      }
    }
    this.loadOriginalPrices()
  },
  watch: {
    initial_ratio: function (value) {
      this.selected_initial_ratio = value || '10'
      this.calcOrder2()
    },
    'storeTotal.order_amount': function () {
      this.calcOrder2()
    }
  },
  methods: {
    displayVolume (volume) {
      var value = parseFloat(volume)
      if (!value) {
        return 0
      }
      return value.toFixed(6).replace(/\.?0+$/, '')
    },
    getShipFrom (goods) {
      var warehouse = goods.warehouse_info || goods.warehouse || {}
      var countryName = goods.country_name || goods.warehouse_country_name || warehouse.country_name || ''
      var warehouseName = goods.warehouse_name || warehouse.warehouse_name || ''
      return [countryName, warehouseName].filter(Boolean).join(' - ')
    },
    getOriginalPrice (goods) {
      var originalPrices = [goods.goods_marketprice, goods.goods_original_price, this.originalPriceMap[goods.goods_id]]
      return originalPrices.find(price => Number(price) > Number(goods.goods_price)) || ''
    },
    loadOriginalPrices () {
      var goodsIds = []
      for (var storeId in this.storeCartList) {
        var goodsList = this.storeCartList[storeId].goods_list || []
        for (var i = 0; i < goodsList.length; i++) {
          if (goodsIds.indexOf(goodsList[i].goods_id) === -1) {
            goodsIds.push(goodsList[i].goods_id)
          }
        }
      }
      goodsIds.forEach(goodsId => {
        getGoodsInfo(goodsId).then(res => {
          var goodsInfo = res.result && res.result.goods_info ? res.result.goods_info : {}
          if (Number(goodsInfo.goods_marketprice) > 0) {
            this.$set(this.originalPriceMap, goodsId, goodsInfo.goods_marketprice)
          }
        }).catch(() => {})
      })
    },
    goBuy (goods_id, goods_num) {
      var params = { buy_now: 1, cart_id: goods_id + '|' + goods_num }
      this.$router.push({ name: 'MemberBuyStep1', query: params })
      this.$router.go(0)
    },
    inputLoseFocus (id, goods_num, moq_num) {
      var buy_now = this.$route.query.buy_now
      if (buy_now == 1) {
        if (moq_num > 0 && goods_num < moq_num) {
          Toast('The goods did not reach the MOQ')
          setTimeout(function () {
            window.location.reload()
          }, 1000)
        } else {
          var params = { buy_now: 1, cart_id: id + '|' + goods_num }
          this.$router.push({ name: 'MemberBuyStep1', query: params })
          this.$router.go(0)
        }
      } else {
        Indicator.open(this.indicator)
        cartUpdate(id, goods_num).then(
          res => {
            if (res) {
              window.location.reload()
            }
          },
          error => {
            Toast(error.message)
            Indicator.close(this.indicator)
            setTimeout(function () {
              window.location.reload()
            }, 1000)
          }
        )
      }
    },
    selectChain (chain) {
      this.chainInfo = chain
      for (var store_id in this.storeCartList) {
        this.calcOrder(store_id)
      }
      this.showChain = false
      this.$emit('selectChain', this.chainInfo, this.goodsInfo)
    },
    getChainList (goods_id, goods_num, area_id) {
      getChainList({ goods_id: goods_id, num: goods_num, area_id: area_id }).then(res => {
        this.chainList[goods_id] = res.result.chain_list
        this.chainCount = this.chainList[goods_id].length
        this.$forceUpdate()
      })
    },
    changeMessage (store_id) {
      this.$emit('changeMessage', this.message[store_id], store_id)
    },
    selectVoucher (voucherInfo, store_id) {
      this.toggleVoucher(store_id)
      this.$emit('selectVoucher', voucherInfo, store_id)
      this.storeCartList[store_id].store_voucher_info = voucherInfo
      this.calcOrder(store_id)
    },
    calcOrder (store_id) {
      // let price = parseFloat(this.finalTotalList[store_id])
      // let price2 = parseFloat(this.storeTotal.order_amount)
      //
      // if (this.storeCartList[store_id].store_voucher_list.length) {
      //   if (this.storeCartList[store_id].store_voucher_info) {
      //
      //     price -= parseFloat(this.storeCartList[store_id].store_voucher_info.voucher_price)
      //     price2 -= parseFloat(this.storeCartList[store_id].store_voucher_info.voucher_price)
      //
      //     if (typeof (this.myVoucher[store_id]) === 'undefined') {
      //       this.myVoucher[store_id] = ''
      //     }
      //     this.myVoucher.splice(store_id, 1, '- $' + this.storeCartList[store_id].store_voucher_info.voucher_price)
      //   } else {
      //     this.myVoucher.splice(store_id, 1, 'Not used')
      //   }
      // }
      // if (this.chainInfo) {
      //   price -= this.addressApi.content[store_id]
      //   price2 -= this.addressApi.content[store_id]
      // }
      // if (price < 0) {
      //   price = 0
      // }
      // if (price2 < 0) {
      //   price2 = 0
      // }
      //
      // console.log(price2);
      //
      // this.storeTotal.order_amount = price2
      //
      // let new_price = parseFloat(price2)*this.initial_ratio/100
      // new_price = Math.ceil(new_price)
      // if (new_price > price2) {
      //   new_price = price2
      // }
      // this.order_amount2 = new_price

      // 确保 store_amounts 对象已初始化
      if (!this.storeTotal.store_amounts) {
        this.$set(this.storeTotal, 'store_amounts', {})
      }

      // 1. 获取店铺基础金额
      const basePrice = parseFloat(this.finalTotalList[store_id] || 0)
      let finalStorePrice = basePrice

      // 2. 处理优惠券逻辑
      var storeCart = this.storeCartList[store_id]
      if (storeCart && storeCart.store_voucher_list && storeCart.store_voucher_list.length) {
        if (storeCart.store_voucher_info) {
          var voucherPrice = parseFloat(storeCart.store_voucher_info.voucher_price || 0)

          // 应用优惠券折扣
          finalStorePrice -= voucherPrice

          // 更新优惠券显示
          this.$set(this.myVoucher, store_id, '- $' + voucherPrice)
        } else {
          // 取消优惠券时恢复原始金额
          finalStorePrice = basePrice
          this.$set(this.myVoucher, store_id, 'Not used')
        }
      }

      // 3. 处理运费逻辑
      if (this.chainInfo && this.addressApi && this.addressApi.content) {
        var shippingFee = parseFloat(this.addressApi.content[store_id] || 0)
        finalStorePrice -= shippingFee
      }

      // 4. 确保金额不小于0
      finalStorePrice = Math.max(finalStorePrice, 0)

      // 5. 更新店铺金额
      this.$set(this.storeTotal.store_amounts, store_id, finalStorePrice)

      // 6. 重新计算总金额（所有店铺金额之和）
      var orderAmount = 0
      var finalTotalKeys = Object.keys(this.finalTotalList)

      for (var i = 0; i < finalTotalKeys.length; i++) {
        var key = finalTotalKeys[i]
        var storePrice = 0

        // 如果该店铺已计算过，使用计算后的金额，否则使用原始金额
        if (this.storeTotal.store_amounts[key] !== undefined) {
          storePrice = this.storeTotal.store_amounts[key]
        } else {
          storePrice = parseFloat(this.finalTotalList[key] || 0)
        }

        orderAmount += storePrice
      }

      this.storeTotal.order_amount = orderAmount

      // 7. 计算 order_amount2
      var ratio = this.selected_initial_ratio || 100
      var new_price = Math.ceil(orderAmount * ratio / 100)
      this.order_amount2 = Math.min(new_price, orderAmount)

      // console.log('店铺 ' + store_id + ' 更新: 基础金额=' + basePrice +
      //     ', 最终金额=' + finalStorePrice +
      //     ', 总金额=' + orderAmount +
      //     ', order_amount2=' + this.order_amount2);
    },
    calcOrder2 () {
      let price = parseFloat(this.storeTotal.order_amount)

      // if (this.storeCartList[store_id].store_voucher_list.length) {
      //   if (this.storeCartList[store_id].store_voucher_info) {
      //     price -= parseFloat(this.storeCartList[store_id].store_voucher_info.voucher_price)
      //     if (typeof (this.myVoucher[store_id]) === 'undefined') {
      //       this.myVoucher[store_id] = ''
      //     }
      //     this.myVoucher.splice(store_id, 1, this.storeCartList[store_id].store_voucher_info.voucher_price + 'dollar')
      //   } else {
      //     this.myVoucher.splice(store_id, 1, 'Not used')
      //   }
      // }

      if (price < 0) {
        price = 0
      }
      this.order_amount2 = price
      let new_price = parseFloat(price) * this.selected_initial_ratio / 100
      new_price = Math.ceil(new_price)
      if (new_price > price) {
        new_price = price
      }
      this.order_amount2 = new_price
    },
    toggleVoucher (store_id) {
      if (typeof (this.voucherVisible[store_id]) === 'undefined') {
        this.voucherVisible[store_id] = false
      }
      this.voucherVisible.splice(store_id, 1, !this.voucherVisible[store_id])
    },
    changeInitial (even, store_id) {
      this.selected_initial_ratio = even.target.value
      this.$emit('changeInitial', this.selected_initial_ratio)
      this.calcOrder(store_id)
    },
    changeInitial2 (even) {
      this.selectDepositRatio(even.target.value)
    },
    openDepositRatio () {
      this.depositRatioVisible = true
    },
    selectDepositRatio (ratio) {
      this.selected_initial_ratio = ratio
      this.depositRatioVisible = false
      this.$emit('changeInitial2', this.selected_initial_ratio)
      this.calcOrder2()
    }
  }
}
</script>

<style scoped lang="scss">
.store{
    position: relative;
    z-index: 1;
    display: block;
    height: 0.9rem;
    padding: 0.5rem;
    font-size: 0.7rem;
    line-height: 0.9rem;
    border-bottom: solid 0.05rem #EEE;
}
.store i{
        display: inline-block;
        width: 0.8rem;
        height: 0.9rem;
        margin-right: 0.2rem;
        vertical-align: middle;
    }
    .cart-item{background-color: #FFF;
        border-bottom: solid 0.05rem #EEE;}
    .buy-item{    display: block;
        position: relative;
        z-index: 1;
        margin:0 0.5rem;
        padding: 0.5rem 0;}
    .buy-item .goods-pic{display: block;
        width: 2.7rem;
        height: 2.7rem;
        padding: 0.2rem;
        position: absolute;
        z-index: 1;
        top: 0.5rem;
        left: 0rem;
        border: solid 0.05rem #EEE;
        border-radius: 0.2rem;}
.buy-item .goods-pic img{width: 2.7rem;
    height: 2.7rem;}
.buy-item .goods-info{    display: block;
        vertical-align: top;
        height: 3.1rem;
        margin-left:4rem;
        position: relative;
        z-index: 1;}
.buy-item .goods-info.has-ship-from{height: 4.1rem;}
.buy-item .goods-info .link{font-size:.7rem;color:$primaryColor;margin-top:.3rem}
.buy-item .goods-info .goods-name a {
    display: block;
    height:1rem;
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    overflow: hidden;
}
.buy-item .goods-info  .goods-type {
    overflow: hidden;
    white-space: nowrap;
    width: 70%;
    height: 0.9rem;
    font-size: 0.45rem;
    line-height: 0.9rem;
    color: #999;
    text-overflow: ellipsis;
}
.buy-item .goods-info .goods-original-price{text-decoration: line-through;font-size:.65rem;color:#999}
.buy-item .goods-info  .goods-subtotal {
    display: block;
    height: 1rem;
    margin: 0 0.5rem 0 0rem;
    line-height: 1rem;
    font-size: 0.7rem;
    position: relative;
    z-index: 1;
}
.buy-item .goods-info  .goods-subtotal .goods-price {
    color: #DB4453;
    font-size: 0.7rem;
    font-weight: 600;
}
.buy-item .goods-info  .goods-subtotal  .goods-count {
    font-size: 0.7rem;
    line-height: 1rem;
    position: absolute;
    z-index: 1;
    top: 0rem;
    right: 1rem;
}
.buy-item .goods-info  .goods-subtotal  .goods-count .number{
    width: 2rem;
    line-height: 1rem;
    padding: 0 0.2rem;
    border: 1px solid #c7c7cd;
    border-radius: 0;
    border-image-width: 0;
    -webkit-box-shadow: 0;
    box-shadow: 0;
    vertical-align: middle;
}
.buy-item .goods-info .goods-ship-from {
    height: 1rem;
    margin: 0 0.5rem 0 0;
    overflow: hidden;
    color: #7c7f88;
    font-size: 0.6rem;
    line-height: 1rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.buy-item .goods-info  .goods-subtotal  .goods-count .number.readonly{
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    color: #333;
    background: #fff;
}
 .cart-subtotal{}
.cart-subtotal dl {
    position: relative;
    z-index: 1;
    height: 1rem;
    padding: 0.4rem 0 0;
    font-size: 0;
}
.cart-subtotal dt {
    position: absolute;
    z-index: 1;
    top: 0.4rem;
    left: 0.4rem;
    display: block;
    width: 50%;
    height: 1rem;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal dd {
    height: 1rem;
    margin: 0 0.5rem 0 50%;
    text-align: right;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal .message {
    position: relative;
    z-index: 1;
    display: block;
    padding-top: 0.4rem;
}
.desc-item {
    height: 1.5rem;
}
.common-voucher{margin:0.5rem auto}
.left-icon{float:left;font-size:0.9rem;margin-right:0.2rem;}
.chain-item{padding:.5rem;}
.chain-item .chain-name{font-size:.8rem;margin-bottom:.3rem}
.chain-item .chain-desc{font-size:.6rem;color:#666}
.cart_item{}
.cart_item .dl{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  height: 2rem;
}
.cart_item .dl .dt{
  width: 7rem;
  font-size: 0.6rem;
  color: #333;
  margin-left: 0.85rem;
}
.cart_item .dl .dd{
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 1rem;
  margin-right: 0.75rem;
  color: #333;
  font-size: 0.75rem;
  text-align: right;
}
.cart_item .dl .dd em{
  color: #e93b3d;
  margin-right: 5px;
}
.cart_item .dl .dd .select{
  display: inline-block;
  width: 80px;
  height: 30px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  padding: 2px 2px 2px 5px;
}
.cart_item .dl + .dl {
  border-top: 1px solid #f2f2f2;
}
.deposit-select {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  width: 4.6rem;
  height: 1.75rem;
  padding: 0 1.1rem 0 0.4rem;
  border: 0;
  border-bottom: 1px solid #d8d8d8;
  background: transparent;
  color: $primaryColor;
  font-size: 0.7rem;
  line-height: 1.75rem;
  box-sizing: border-box;
}
.deposit-select:after {
  content: '';
  position: absolute;
  top: 0.6rem;
  right: 0.35rem;
  width: 0.35rem;
  height: 0.35rem;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  transform: rotate(45deg);
}
.deposit-select:active {
  background: #fafafa;
}
.deposit-ratio-popup {
  width: 100%;
  max-height: 70vh;
  overflow: hidden;
  background: #fff;
  border-radius: 0.5rem 0.5rem 0 0;
}
.deposit-picker {
  width: 100%;
  background: #fff;
}
.deposit-picker-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 2.75rem;
  padding: 0 0.85rem;
  border-bottom: 1px solid #eee;
  color: #222;
  font-size: 0.75rem;
  font-weight: 600;
  box-sizing: border-box;
}
.deposit-picker-hd button {
  min-width: 3rem;
  padding: 0.45rem 0 0.45rem 0.75rem;
  border: 0;
  background: transparent;
  color: $primaryColor;
  font-size: 0.7rem;
  line-height: 1rem;
}
.deposit-options {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.5rem;
  padding: 0.85rem;
  box-sizing: border-box;
}
.deposit-options button {
  width: 100%;
  height: 2.1rem;
  padding: 0;
  border: 1px solid #d9d9d9;
  border-radius: 0.2rem;
  background: #fff;
  color: #333;
  font-size: 0.7rem;
  line-height: 2rem;
  box-sizing: border-box;
}
.deposit-options button.active {
  border-color: $primaryColor;
  background: #fff4f4;
  color: $primaryColor;
  font-weight: 600;
}

.volume {
  height: 1.5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
}
.volume .title {
  width: 7rem;
  font-size: 0.6rem;
  color: #333;
  margin-left: 0.85rem;
}
.volume .subtitle {
  flex: 1;
  margin-left: 1rem;
  margin-right: 0.75rem;
  color: $primaryColor;
  font-size: 0.75rem;
  text-align: right;
}
</style>
